import React, { useState } from "react";
import styles from "./style.module.css";
import {
  filterLoanHistoryList,
  getUniqueLoanStatuses,
  filterLoanStatus,
  showLoanStatusMessage,
} from "../../../../utils/loan";
import LoanCard from "../../../../components/card/LoanCard";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLoanStore } from "../../../../stores/useLoanStore";


const LoanHistory = ({ loans }) => {
  const [filter, setFilter] = useState({ loanStatus: "" });

  const { t, i18n } = useTranslation('myLoan');

  const loanStatuses = getUniqueLoanStatuses(loans);
  
  const matchedLoanStatuses = ["close", "cancel", "reject"];

  const pastLoans = filterLoanHistoryList(loans);

  const filteredLoans = filterLoanStatus(pastLoans, filter.loanStatus);

  const navigate = useNavigate();

  const setIncomeFormProfile = useLoanStore((state) => state.setIncomeFormProfile);

  function handleNavigateToRenewLoan() {
    setIncomeFormProfile({ monthly_income: 50000, out_time_income: "", other_income: "", is_mou: false });
    navigate("/select-loan");
  }

  return (
    <div className={styles.container}>
      {loans?.length > 0 && (
        <select onChange={(e) => setFilter({ loanStatus: e.target.value })}>
          <option value="">{t('selectStatus')}</option>
          {matchedLoanStatuses.map((status) => (
            <option key={status} value={status}>
              {t(status)}
            </option>
          ))}
        </select>

      )}
      {filteredLoans?.length > 0 ? (
        <div className={styles.loanList}>
          {filteredLoans.map((loan) => (
            <LoanCard loan={loan} />
          ))}
        </div>
      ) : (
        <section className={styles.notFound}>
          <h1>{t('doNotFoundHistory')}</h1>
          <button
            className={styles.applyButton}
            onClick={handleNavigateToRenewLoan}
          >
            {t('Register')}
          </button>
        </section>
      )}
    </div>
  );
};

export default LoanHistory;
